import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"

export default class extends Controller {
  static get targets() {
    return ["includeButton", "excludeButton", "label"]
  }

  static get values() {
    return {
      tag: String,
      included: true
    }
  }

  connect() {
    if (this.includedValue) {
      this.includeButtonTarget.classList.add("active")
      this.excludeButtonTarget.classList.remove("active")
      this.labelTarget.classList.remove("tag--danger")
    } else {
      this.includeButtonTarget.classList.remove("active")
      this.excludeButtonTarget.classList.add("active")
      this.labelTarget.classList.add("tag--danger")
    }
  }

  removeTag() {
    this.dispatch("tagRemoved", { detail: { tagValue: this.tagValue, included: this.includedValue, dataset: this.element.dataset } })
    this.element.remove()
  }

  includeTag() {
    if (this.includedValue === true) {
      return
    }

    this.includedValue = true
    this.includeButtonTarget.classList.add("active")
    this.excludeButtonTarget.classList.remove("active")
    this.labelTarget.classList.remove("tag--danger")
    this._dispatchTagChanged()
  }

  excludeTag() {
    if (this.includedValue === false) {
      return
    }

    this.includedValue = false
    this.includeButtonTarget.classList.remove("active")
    this.excludeButtonTarget.classList.add("active")
    this.labelTarget.classList.add("tag--danger")
    this._dispatchTagChanged()
  }

  _dispatchTagChanged() {
    this.dispatch(
      "tagChanged",
      {
        detail: { tagValue: this.tagValue, included: this.includedValue, dataset: this.element.dataset }
      }
    )
  }
}
